import { Form, FormInstance } from 'antd';
import React from 'react';
import { omit } from 'lodash';
import { RangePickerDateProps } from 'antd/es/date-picker/generatePicker';
import { Moment } from 'moment';
import { Translations } from '../filter-bar-2';
import { SelectableList, RangeCalender } from 'components';

interface Props {
	name?: string;
	onFilterChange: () => void;
	datePickerProps?: Omit<RangePickerDateProps<Moment>, 'value' | 'onChange'>;
	translations: Translations;
	form: FormInstance;
}

export const FilterContentDateRange: React.FC<Props> = ({
	name,
	onFilterChange,
	datePickerProps,
	translations,
	form
}) => {
	const pickerProps = omit(datePickerProps, ['ranges']);
	const handleQuickSelection = (range: [Moment, Moment]) => {
		form.setFieldsValue({ [name]: range });
		onFilterChange();
	};

	return (
		<>
			<div className="range-picker-sub-title">{translations.specifiedPeriod}</div>
			<Form.Item name={name}>
				<RangeCalender onChange={onFilterChange} {...pickerProps} />
			</Form.Item>
			{datePickerProps?.ranges && (
				<>
					<div className="range-picker-sub-title range-picker-title-border-top">{translations.preset}</div>
					<SelectableList
						className="quick-ranges-list"
						itemClassName="quick-range-item"
						items={Object.keys(datePickerProps.ranges)}
						onSelect={item => handleQuickSelection(datePickerProps.ranges[item] as [Moment, Moment])}
					/>
				</>
			)}
		</>
	);
};
